import { render } from "./CommentTask.vue?vue&type=template&id=39a78dd6"
import script from "./CommentTask.vue?vue&type=script&lang=js"
export * from "./CommentTask.vue?vue&type=script&lang=js"

import "./CommentTask.vue?vue&type=style&index=0&id=39a78dd6&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__